import React from 'react';
import { SectionLabel } from './SectionLabel';
import { Bloom } from './Bloom';
import { LeadFlowVisual } from './LeadFlowVisual';
const points = ['Answers calls 24/7, including nights, weekends, and the middle of a job.', 'Texts back the ones you miss in seconds, while they are still holding the phone.', 'Books estimates straight onto your calendar instead of taking a message.', 'Built and tuned with you on a setup call: your services, your area, your words.'];
export function AIReceptionist() {
  return <section className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-127" data-mp="3vez46vfbljdg">
      <Bloom size="md" className="right-0 top-[-8rem]" data-id="element-128" data-mp="41cn3kxu8a26" />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-14 px-6 py-20 lg:grid-cols-2 lg:py-24" data-id="element-129" data-mp="43yt3g52yhia">
        <div data-id="element-130" data-mp="e0bvr3ils5p6">
          <SectionLabel data-id="element-131" data-mp="e0ld62pl14j9">AI receptionist</SectionLabel>
          <h2 className="mt-8 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-132" data-mp="dxz3nxj4seye">
            Somebody picks up. Even when nobody can.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-neutral-400" data-id="element-133" data-mp="21pm8i7gqae8q">
            It talks to the caller, answers what you told it to answer, and puts the estimate on
            your calendar.
          </p>
          <ul className="mt-8 space-y-4" data-id="element-134" data-mp="1rq3ojr0tisgo">
            {points.map(p => <li key={p} className="flex gap-3 text-sm leading-relaxed text-neutral-300" data-id="element-135" data-mp="1ms26n9f4oz6s">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-136" data-mp="2kdhfn8hu4tsv" />
                {p}
              </li>)}
          </ul>
        </div>
        <div className="order-first lg:order-none" data-id="element-137" data-mp="2ammqnwd7fg3q">
          <LeadFlowVisual data-id="element-138" data-mp="25ol9xi393svf" />
        </div>
      </div>
    </section>;
}